module.exports = __webpack_public_path__ + "img/DF_white_arrow_left_desktop.7453da46.svg";